;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { Card } from 'reactstrap';
import SandYouLogo from './svg/SandYouLogo';
import { Dictionaries, Locale } from '../i18n/i18n-config';
import { getI18nUtils } from '../i18n/i18n-utils';

type Props = {
  dictionary: Partial<Dictionaries>;
  locale: Locale;
};

function SandYouTeaser({ dictionary, locale }: Props): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <Card body className="border d-none d-lg-block">
      <SandYouLogo dark className="d-block mx-auto mb-3" />
      <p>
        {formatMessage(
          { id: 'index_section_intro_firstpar' },
          {
            synergieBelgiumLink: (
              <a href={`https://www.synergiejobs.be/${locale}/about`} target="_blank" rel="noopener noreferrer">
                Synergie Belgium
              </a>
            ),
          }
        )}
      </p>
    </Card>
  );
}

export default SandYouTeaser;
